export default "__VITE_ASSET__BysXmPAV__"